<template>
  <div
    class="grid h-full w-full z-0"
    :style="gridStyle"
  >
    <div
      v-for="(styleObj, idx) in orderedImages"
      :key="idx"
      class="bg-cover bg-center"
      :style="styleObj"
    ></div>
  </div>
</template>

<script>
// Explicit imports (fastest when you have a small, fixed set)
import img1 from '@/assets/images/iStock-1183627655.webp';
import img2 from '@/assets/images/iStock-179985599.webp';
import img3 from '@/assets/images/iStock-2149785775.webp';
import img5 from '@/assets/images/iStock-2164344540.webp';

export default {
  name: 'BackgroundImage', // keep this consistent with how you register/use it
  props: {
    columnWidths:   { type: String, required: true },  // e.g. '623fr 157fr 312fr 32fr 436fr'
    imagesOrder:    { type: Array,  default: () => [0, 1, 2, 3, 4] },
    imagesIncluded: { type: Array,  default: null }
  },
  computed: {
    gridStyle() {
      return { gridTemplateColumns: this.columnWidths };
    },
    // Use imported URLs for background images (Vite will fingerprint & rewrite)
    imageStyles() {
      return [
        { backgroundImage: `url(${img1})` },                                     // 0
        { backgroundImage: `url(${img2})` },                                     // 1
        { backgroundImage: `url(${img3})` },                                     // 2
        { background: 'linear-gradient(180deg, #FFDC78 0%, #F9C646 100%)' },     // 3 (your yellow tile)
        { backgroundImage: `url(${img5})` },                                     // 4
      ];
    },
    orderedImages() {
      const order = Array.isArray(this.imagesOrder)
        ? this.imagesOrder.map(Number).filter(Number.isInteger)
        : [];
      const includeSet = Array.isArray(this.imagesIncluded)
        ? new Set(this.imagesIncluded.map(Number).filter(Number.isInteger))
        : null;

      const result = [];
      const used = new Set();

      for (const i of order) {
        if (i >= 0 && i < this.imageStyles.length) {
          if (includeSet && !includeSet.has(i)) continue;
          result.push(this.imageStyles[i]);
          used.add(i);
        }
      }

      if (includeSet) {
        for (const raw of this.imagesIncluded) {
          const idx = Number(raw);
          if (!Number.isInteger(idx)) continue;
          if (idx >= 0 && idx < this.imageStyles.length && !used.has(idx)) {
            result.push(this.imageStyles[idx]);
            used.add(idx);
          }
        }
      } else {
        this.imageStyles.forEach((s, i) => {
          if (!used.has(i)) result.push(s);
        });
      }

      return result;
    },
  },
};
</script>